import { Component, Input, inject } from '@angular/core';
import { SiCardComponent } from '@siemens/element-ng/card';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { ModalRef, SiModalService } from '@siemens/element-ng/modal';
import { TranslatePipe } from '@ngx-translate/core';
import type { Card } from '../../interfaces/ICardItem';
import { TileService } from '../../services/tile.service';
import { TileDialogComponent } from './tile-dialog/tile-dialog.component';

@Component({
    selector: 'app-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss'],
    imports: [SiCardComponent, SiIconComponent, TranslatePipe]
})
export class TileComponent {
    private modalService = inject(SiModalService);
    private tileService = inject(TileService);
    private modalRef?: ModalRef<unknown, string>;

    @Input() tile!: Card;

    showTileInfo(): void {
        this.modalRef?.hide('reopen');
        this.modalRef = this.modalService.show(
            TileDialogComponent,
            {
                inputValues: { tileData: this.tile },
                ignoreBackdropClick: false,
                keyboard: true,
                animated: true,
                class: 'modal-xl',
                ariaLabelledBy: 'tile-dialog-title'
            },
            'close'
        );

        this.modalRef.hidden.subscribe(() => {
            this.modalRef = undefined;
        });
    }

    downloadFile(): void {
        if (this.tile.key) {
            this.tileService.readDocument(this.tile.key).then((signedfileUrl: string | boolean) => {
                if (typeof signedfileUrl === 'string') {
                    this.triggerBrowserDownload(signedfileUrl);
                }
            });
        }
    }

    private triggerBrowserDownload(url: string): void {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
